import { Price } from './price-cap'

export interface SharedAccessBasePrice {
  priceCategoryId: string
  prices: Price[]
}

export interface SharedAccessBeneficiaryPrice {
  priceCategoryId: string
  prices: Price[]
}

export interface SharedAccess {
  maxBeneficiaries?: number
  basePrices?: SharedAccessBasePrice[]
  beneficiaryPrices?: SharedAccessBeneficiaryPrice[]
  /** Locker sizes not participating in shared access pricing. */
  excludedCategoryIds?: string[]
}

export function collectSharedAccessExcludedCategoryIds(
  basePriceCategories: readonly {
    categoryId?: string
    excludedFromSharedAccess?: boolean
  }[],
  alsoExcluded?: ReadonlySet<string>
): string[] {
  const ids = new Set<string>(alsoExcluded ?? [])
  for (const cat of basePriceCategories) {
    if (cat.excludedFromSharedAccess && cat.categoryId) {
      ids.add(cat.categoryId)
    }
  }
  return [...ids]
}

export function isSharedAccessCategoryExcluded(
  categoryId: string,
  excludedFromForm: boolean,
  manualExcluded: ReadonlySet<string>,
  savedExcluded: ReadonlySet<string>
): boolean {
  return (
    excludedFromForm ||
    manualExcluded.has(categoryId) ||
    savedExcluded.has(categoryId)
  )
}

export function readSharedAccessExcludedCategoryIdsFromPayload(
  payload: unknown
): string[] {
  if (payload === null || payload === undefined || typeof payload !== 'object') {
    return []
  }
  const raw = (payload as Record<string, unknown>)['excludedCategoryIds']
  if (!Array.isArray(raw)) {
    return []
  }
  return raw.filter(
    (id): id is string => typeof id === 'string' && id.length > 0
  )
}
